import {Pipe, PipeTransform} from '@angular/core';
import {clpp} from '@castlabs/prestoplay';

/**
 * Format the language code of a `clpp.Track` object. If the original language has private use tags (`-x-FOO`),
 * it is formatted appropriately.
 */
@Pipe({
    name: 'formatTrackLanguage'
})
export class FormatTrackLanguagePipe implements PipeTransform {
  transform(value: clpp.Track): string {
    const privateUseSubtags = value.originalLanguage.match(/-x-(.+)/);
    if (!privateUseSubtags) {
      return value.language
    }

    // If the language tag only has language part (`pt`, not `pt-br`), clpp.utils.LanguageUtils uses the `-x-` as
    // the territory in the normalized language. So, renormalize here.
    // Output looks like:
    // en-x-vtt -> en (vtt)
    // pt-br-x-vtt -> pt-BR (vtt)
    // fr-ca-x-foo-bar -> fr-CA (foo, bar)
    let lang: string;

    if (value.language.endsWith('-X')) {
      // language-only was normalized incorrectly: en-x-vtt -> en-X
      lang = value.language.split('-')[0];
    } else {
      // this is a language-territory, so it was normalized correctly: pt-br-x-vtt -> pt-BR
      lang = value.language;
    }

    const subtags = privateUseSubtags.slice(1).join(', ');
    return `${lang} (${subtags})`
  }
}
